import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    /**
     * Retry only on allow listed exceptions and up to a maximum of 5 times
     */
    queries: {
      retry(failureCount, error) {
        // Retry only up to 5 times
        if (failureCount >= 5) {
          return false;
        }

        // Retry only on allow listed exceptions
        if (axios.isAxiosError(error)) {
          // Allow retries on network errors, network disconnects etc...
          if (error.message === 'Network Error') {
            return true;
          }

          // Allow retries on internal errors, likely bug or downtime
          if ((error.response?.status ?? 0) >= 500) {
            return true;
          }
          return [401, 403, 404].includes(error.response?.status ?? 0);
        }

        return false;
      },
      // Exponential backoff
      retryDelay: (attemptIndex) => {
        return Math.min(500 * 2 ** attemptIndex, 10_000);
      },
      staleTime: 1000 * 60 * 10, // 10 minutes
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  },
});
